import type { RegisterImplementationProps } from 'constants/types';
import MultiSignInBase, { type MultiSignInStep } from '../MultiSignInBase';
import { getProviderFormLabel } from '../utils';
import Credentials from './MultiSignIn/Credentials';
import Webservice from './MultiSignIn/Webservice';
import Welcome from './MultiSignIn/Welcome';

const SignInUltiProApiMultiStep = ({
  client,
  isLoading,
  onSubmit,
  provider,
  instructionsLink,
  instructionsInnerHtmlToScroll,
  instructionsInnerHtmlToScrollStep2,
  sandboxMode,
}: RegisterImplementationProps) => {
  const steps: MultiSignInStep[] = [
    {
      id: 'welcome',
      title: `Let's create your connection`,
      fieldNames: [],
      welcomePage: true,
      spacing: 'md',
    },
    {
      id: 'credentials',
      title: 'Create a Service Account',
      fieldNames: ['username', 'password'],
      spacing: 'sm',
    },
    {
      id: 'webservice',
      title: 'Retrieve API Keys & Web Service URL',
      fieldNames: ['apiToken', 'tenantId', 'fullDomain'],
      spacing: 'sm',
    },
  ];

  return (
    <MultiSignInBase
      formLabel={getProviderFormLabel(provider)}
      steps={steps}
      onSubmit={onSubmit}
      isLoading={isLoading}
      render={(fields, currentStep) => {
        // Step 0: Welcome page
        if (currentStep === 0) {
          return <Welcome client={client} provider={provider} />;
        }

        // Step 1: Credentials
        if (currentStep === 1) {
          return (
            <Credentials
              username={fields.username}
              password={fields.password}
              instructionsLink={instructionsLink}
              instructionsInnerHtmlToScroll={instructionsInnerHtmlToScroll}
            />
          );
        }

        // Step 2: Webservice
        if (currentStep === 2) {
          return (
            <Webservice
              apiToken={fields.apiToken}
              tenantId={fields.tenantId}
              fullDomain={fields.fullDomain}
              sandboxMode={!!sandboxMode}
              instructionsLink={instructionsLink}
              instructionsInnerHtmlToScroll={instructionsInnerHtmlToScrollStep2}
            />
          );
        }

        return null;
      }}
    />
  );
};

export default SignInUltiProApiMultiStep;
